export default __webpack_public_path__ + "static/media/mobile7.1e06a0b4.webp";